import React from "react";
import { Loading } from "../../components";
import { ApiHelper, CommissionCheckInterface, DateHelper, UserHelper } from "../../helpers";
import { Link, Redirect } from "react-router-dom";

interface Props {

}


export const CommissionChecks: React.FC<Props> = props => {

  const [checks, setChecks] = React.useState<CommissionCheckInterface[]>(null);
  const [redirect, setRedirect] = React.useState("");

  const init = async () => {
    ApiHelper.get("/commissionChecks/").then(d => setChecks(d));
  }

  React.useEffect(() => { init() }, []); //eslint-disable-line


  const newCheck = () => {
    const check: CommissionCheckInterface = { paymentDate: new Date(), totalAmount: 0, accountId: UserHelper.currentDepartment.accountId };
    ApiHelper.post("/commissionchecks", [check]).then(data => {
      setRedirect("/settings/affiliate/check/" + data[0].id);
    })
  }

  if (redirect !== "") return <Redirect to={redirect} />
  else if (!checks) return <Loading />
  else {
    const formatter = Intl.NumberFormat("en-US", { style: "currency", currency: "USD" });
    const rows: JSX.Element[] = [];
    let sum = 0;
    checks.forEach(c => {
      const d = DateHelper.convertToDateOnly(c.paymentDate);
      sum += c.totalAmount
      rows.push(<tr>
        <td><Link to={"/settings/affiliate/check/" + c.id}>{DateHelper.formatDateTime(d, "MMM yyyy")}</Link></td>
        <td>{formatter.format(c.totalAmount)}</td>
      </tr>);
    });
    rows.push(<tr>
      <td><b>Total</b></td>
      <td><b>{formatter.format(sum)}</b></td>
    </tr>)

    let result = <p>No commission checks have been mailed yet.</p>;
    if (checks.length > 0) result = (<table className="table table-sm table-sriped" >
      <thead>
        <tr>
          <th>Date</th>
          <th>Amount</th>
        </tr>
      </thead>
      <tbody>
        {rows}
      </tbody>
    </table>);
    return (<>
      {result}
      {(UserHelper.checkAccess("admin") && <a href="about:blank" onClick={(e) => { e.preventDefault(); newCheck(); }}>Add Check</a>)}
    </>);

  }
};